import api from "app/api";
import { useParams } from "common/components/Form/ParamsContext";
import { useEffect, useState } from "react";
import { getPartnerCommissionService } from "./partnerCommissionApi";

export default function usePartnerCommissionList() {
  const params = useParams();
  const scope = { partners: params.partner_id };
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "partner-commissions/"
      : ""
  }`;
  const service = getPartnerCommissionService({ partners: params.partner_id });

  async function requestCheckCommissionCoverage() {
    if (!params?.partner_id) {
      return { success: false, data: null };
    }
    return api.get<{ is_complete: boolean; message: string }>(
      `partners/${params.partner_id}/check-commission-coverage`
    );
  }

  const [coverageStatus, setCoverageStatus] = useState<{
    is_complete: boolean;
    message: string;
  } | null>(null);

  async function checkCommissionCoverage() {
    if (params?.partner_id) {
      const response: any = await requestCheckCommissionCoverage();
      if (response.success && response.data) {
        setCoverageStatus(response.data);
      }
    }
  }

  useEffect(() => {
    checkCommissionCoverage();
  }, [params?.partner_id]);

  return {
    ...service,
    params,
    scope,
    editUrl,
    checkCommissionCoverage,
    coverageStatus,
  } as ReturnType<typeof getPartnerCommissionService> & {
    params: typeof params;
    scope: typeof scope;
    editUrl: string;
    checkCommissionCoverage: typeof checkCommissionCoverage;
    coverageStatus: typeof coverageStatus;
  };
}
